<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout justify-start wrap pt-6>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md3 pl-5 text-center>
                <v-icon color="#9B8DFD">mdi-school</v-icon>
              </v-flex>
              <v-flex xs9 sm9 md9 text-left>
                <span
                  style="
                    font-family: nunitosansbold;
                    font-size: 20px;
                    color: #000000;
                  "
                  >Add School</span
                >
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md9>
              <router-link :to="'/schoolList'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >View School</span
                >
              </router-link>
            </v-flex></v-layout
          >
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 sm12 md12 pa-2>
                <v-text-field
                  v-model="school.name"
                  label="Name"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 pa-2>
                <v-textarea
                  v-model="school.address"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  placeholder="Address"
                ></v-textarea>
              </v-flex>
              <v-layout justify-start wrap>
                <v-flex xs12>
                  <img
                    v-if="imagePreview"
                    :src="imagePreview"
                    v-show="showPreview"
                    width="150px"
                    height="150px"
                    class="align-center"
                    contain
                  />
                </v-flex>
                <v-flex xs12 sm7 md5 lg4>
                  <v-btn
                    width="180px"
                    block
                    tile
                    depressed
                    :ripple="false"
                    class="text-capitalize"
                    color="#F6F5FF"
                    @click="$refs.showImage.click()"
                  >
                    <v-layout justify-center wrap>
                      <v-flex xs2 sm2 md2 text-left>
                        <v-icon style="color: #000000">mdi-upload</v-icon>
                      </v-flex>
                      <v-flex xs10 sm8 md8>
                        <span
                          style="
                            font-family: nunitosanssemibold;
                            color: #020202;
                            font-size: 12px;
                          "
                          >UPLOAD PICTURE
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-btn>
                  <input
                    v-show="false"
                    accept="image/*"
                    id="file"
                    ref="showImage"
                    multiple="multiple"
                    type="file"
                    @change="showImage"
                  />
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md4 py-8>
                <v-btn
                  @click="validateInput"
                  dark
                  block
                  height="50px"
                  style="font-family: nunitosanssemibold"
                  color="#9B8DFD"
                  >ADD School</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
          <!-- <v-layout justify-center wrap>
            <v-flex xs12>
              <v-layout justify-center wrap>
                <v-layout justify-center wrap>
                  <v-flex xs12 class="dottedline"> </v-flex>
                </v-layout>
                <v-flex xs1>
                  <p class="text-center">or</p>
                </v-flex>
                <v-layout justify-center wrap>
                  <v-flex xs12 class="dottedline"> </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout> -->
          <!-- <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 text-center v-if="file">
                 <span>{{file.name}}</span>
              </v-flex>
              <v-flex xs12 md4 offset-md4>
                <v-btn
                  block
                  small
                  dark
                  height="50px"
                  color="#9B8DFD"
                  @click="$refs.showFile.click()">
                  <v-icon style="color: #ffffff">mdi-note-text-outline</v-icon>
                  <span style="font-family: nunitosanssemibold"
                    >UPLOAD CLASS INFO SHEET</span>
                </v-btn>
                <input
                  v-show="false"
                  id="file"
                  ref="showFile"
                  multiple="multiple"
                  type="file"
                  @change="showFile"
                />
                <v-layout justify-center wrap pt-2>
                  <v-flex xs12 text-center>
                    <span style="font-family: nunitosansregular; color: #8f8f8f"
                      >Upload One or Multiple Class Data</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md4 py-2 text-right>
                <a
                  :href="'http://52.66.213.94/u/1625479647296.xlsx'"
                  style="text-decoration: none"
                >
                  <v-btn small plain color="#9B8DFD">
                    <span>Download Template</span>
                    <v-icon>mdi-download-outline</v-icon>
                  </v-btn>
                </a>
              </v-flex>
            </v-layout>
          </v-card-text> -->
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      showsnackbar: false,
      ServerError: false,
      msg: "",
      timeout: 5000,
      showPreview: false,
      file: null,
      imagePreview: "",
      id: "",
      school: {
        name: null,
        address: null,
      },

      studentList: [],
      page: 1,
      user: [],
      group: [],
    };
  },
  mounted() {},
  methods: {
    validateInput() {
      if (!this.school.name) {
        this.msg = "Please Provide Name";
        this.showsnackbar = true;
        return;
      } else if (!this.school.address) {
        this.msg = "Please Provide Address";
        this.showsnackbar = true;
        return;
      } else {
        this.addSchool();
      }
    },
    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showSnackBar = true;
        return;
      }
      this.showPreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    uploadImage(id) {
      let formData = new FormData();
      formData.append("image", this.file);
      formData.append("id", id);
      axios({
        method: "POST",
        url: "/school/image",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.file = null;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    addSchool() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/school/add",
        data: this.school,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "School Added Successully";
            this.showsnackbar = true;
            this.id = response.data.data._id;
            if (this.imagePreview) {
              this.uploadImage(this.id);
            }
            this.$router.push({ path: "/schoolList" });
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.dottedline {
  border: none;
  /* border-top: 1px dashed rgb(208, 208, 208); */
  color: #8f8f8f;
  /* text-align: center; */
  background-color: #8f8f8f;
  height: 1px;
  width: 100%;
}
</style>